export class AssetPortfolioInfo {
  AssetPortfolioID: number
  AssetPortfolioCode: string
  AssetPortfolioName: string
  AssetPortfolioDesc: string
  CreateDate: string
  CreateBy: string
  CreateByName: string
  UpdateDate: string
  UpdateBy: string
  UpdateByName: string
  FlagDelete: string
  rowFetch: number
  rowOFFSet: number
  itemTotal: number
}
